<template>
  <ak-dropdown
    position-x="right"
    :position-y="currentView === 'grid' ? 'top' : 'bottom'"
  >
    <template #trigger>
      <ak-button color="white" size="small" circle>
        <ak-icon size="big" type="more-vertical" />
      </ak-button>
    </template>

    <template #default>
      <ak-dropdown-item v-if="currentView === 'list'" has-link>
        <router-link :to="appLink">Edit</router-link>
      </ak-dropdown-item>
      <ak-dropdown-item @click.stop.prevent="clone(app, 'clone')">
        Clone
      </ak-dropdown-item>

      <ak-dropdown-item @click.stop.prevent="clone(app, 'move')">
        Move
      </ak-dropdown-item>

      <ak-dropdown-item has-link>
        <router-link :to="appSettings">Settings</router-link>
      </ak-dropdown-item>

      <ak-dropdown-item has-link>
        <router-link
          :to="{ name: 'singleAppLeads', params: { appId: app._id } }"
          >View Leads</router-link
        >
      </ak-dropdown-item>

      <template
        v-if="appType === 'pages' && urlBuilderEnabled && app.publishedStatus"
      >
        <ak-dropdown-item has-link>
          <a @click.stop.prevent="createUrl(app)">Create URL</a>
        </ak-dropdown-item>
      </template>

      <ak-dropdown-item has-link>
        <a class="color-danger" @click.stop.prevent="removeApp(app)">Delete</a>
      </ak-dropdown-item>
    </template>
  </ak-dropdown>
</template>

<script>
import Dropdown from '@akerolabs/akero-vue/src/components/dropdown/Dropdown.vue'
import DropdownItem from '@akerolabs/akero-vue/src/components/dropdown/DropdownItem.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import { cloneObject } from '@akerolabs/akero-vue/src/utils/helpers.js'
import { defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-apps-list-actions />
   */
  name: 'AkAppsListActions',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [DropdownItem.name]: DropdownItem,
    [Dropdown.name]: Dropdown,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    app: {
      default: () => ({}),
      type: Object,
    },

    appLink: {
      default: () => ({}),
      type: Object,
    },

    appSettings: {
      default: () => ({}),
      type: Object,
    },

    appType: {
      default: undefined,
      type: String,
    },

    deleteApp: {
      default: () => {},
      type: Function,
    },

    cloneApp: {
      default: () => {},
      type: Function,
    },

    moveApp: {
      default: () => {},
      type: Function,
    },

    createUrl: {
      default: () => {},
      type: Function,
    },

    urlBuilderEnabled: {
      default: false,
      type: Boolean,
    },
    currentView: {
      type: String,
      default: undefined,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const removeApp = (app) => {
      try {
        props.deleteApp(app)
      } catch (ex) {
        /* istanbul ignore next */
        console.log(ex)
      }
    }

    const clone = (app, action) => {
      try {
        props.cloneApp(cloneObject(app), action)
      } catch (ex) {
        /* istanbul ignore next */
        console.log(ex)
      }
    }

    return {
      removeApp,
      clone,
    }
  },
})
</script>
